export enum DisbursementTriggerEnum {
  P1 = "P1",
  PrecatorioPayment = "PrecatorioPayment",
  PrecatrioIssue = "PrecatrioIssue",
  PrecatorioHomologation = "PrecatorioHomologation",
  LOARegistration = "LOARegistration",
  DebtPayment =  "DebtPayment",
  P2 = "P2"
}

export const DisbursementTriggerLabel = new Map<DisbursementTriggerEnum, string>([
  [DisbursementTriggerEnum.P1, "P1"],
  [DisbursementTriggerEnum.PrecatorioPayment, "Pagamento do precatório"],
  [DisbursementTriggerEnum.PrecatrioIssue, "Expedição"],
  [DisbursementTriggerEnum.PrecatorioHomologation, "Homologação"],
  [DisbursementTriggerEnum.LOARegistration, "Registro na LOA"],
  [DisbursementTriggerEnum.DebtPayment, "Pagamento de débitos"],
  [DisbursementTriggerEnum.P2, "P2 Manual"]
]);



// WEBPACK FOOTER //
// ./src/services/Enum/DisbursementTriggerEnum.ts